export const SERVICES_TASK_RENDER_TYPE = (type) => {
  switch (type) {
    case "1":
      return "In Warranty";
    case "2":
      return "No Warranty";
    default:
      break;
  }
};

export const SERVICES_TASK_RENDER_CALL_STATUS = (type) => {
  switch (type) {
    case "1":
      return "YES";
    default:
      return "-";
  }
};

export const SERVICES_TASK_RENDER_SERVICE_STATUS = (type) => {
  switch (type) {
    case "1":
      return "YES";
    default:
      return "-";
  }
};

export const SERVICES_TASK_RENDER_STATUS = (type) => {
  switch (type) {
    case "1":
      return "YES";
    default:
      return "-";
  }
};

export const SERVICES_SUB_TASK_RENDER_PROMOTION = (type) => {
  switch (type) {
    case "1":
      return "Main Promotion";
    case "2":
      return "E-Voucer Code";
    default:
      return "-";
  }
};
